(function () {
  angular
    .module("akitabox.planView.dialogs.markup.edit")
    .service("EditMarkupDialog", EditMarkupDialog);

  /* @ngInject */
  function EditMarkupDialog($mdDialog) {
    var modal = {
      templateUrl:
        "app/desktop/modules/plan-view/dialogs/markup/edit/edit-markup.dialog.html",
      controller: "EditMarkupDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    /**
     * EditMarkupDialog service
     *
     * @type {Object}
     */
    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * `options.locals.building` is required
     * `options.locals.floor` is required
     * `options.locals.markup` is required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error>}              Promise that resolves when the markup is edited
     */
    function show(options) {
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
